import { schema } from 'normalizr'

import CreditNote from '@/models/credit-note'
import Payment from '@/models/payment'

import { paymentsSchema } from './payment'

const creditNoteSchema = new schema.Entity('creditNotes', {
  refunds: paymentsSchema,
})
const creditNotesSchema = new schema.Array(creditNoteSchema)

export interface CreditNotesReponse {
  entities: {
    payments: { [id: number]: Payment }
    creditNotes: { [id: number]: CreditNote }
  }
  result: number[]
  bookingId: number
}

export default creditNoteSchema
export { creditNotesSchema }
